"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLpCfGroupings = exports.createLpToCfMap = void 0;
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
/**
 * Reverse maps CfToLpMap to create LpToCfMap
 */
const createLpToCfMap = (cfToLpMap) => (0, remeda_1.pipe)(cfToLpMap, remeda_1.toPairs, (0, remeda_1.reduce)((lpToCfMap, [cfSlug, lpSlugs]) => {
    (0, remeda_1.forEach)(lpSlugs, (lpSlug) => {
        if (!lpToCfMap[lpSlug]) {
            // eslint-disable-next-line no-param-reassign
            lpToCfMap[lpSlug] = [];
        }
        lpToCfMap[lpSlug].push(cfSlug);
    });
    return lpToCfMap;
}, {}), (0, remeda_1.mapValues)((cfSlugs) => (0, remeda_1.uniq)(cfSlugs)));
exports.createLpToCfMap = createLpToCfMap;
/**
 * Creates groupings of associated loanProductSlugs and creditFacilitySlugs
 *
 * Note: this can return ids or slugs based on the input maps provided
 */
const getLpCfGroupings = ({ cfToLpMap, lpToCfMap, }) => {
    // reverse map cfToLpMap for easy lookup
    // keep track of visited cfSlugs
    const visitedCfSlugs = new Set();
    // init global result
    const meshes = [];
    Object.keys(cfToLpMap).forEach((creditFacilitySlug) => {
        // if we have already visited this cfSlug, skip it
        if (visitedCfSlugs.has(creditFacilitySlug))
            return;
        // init queue for BFS
        const queue = [creditFacilitySlug];
        // init lpSlugs for this BFS pass
        const lpSlugSet = new Set();
        const cfSlugSet = new Set();
        // eslint-disable-next-line no-restricted-syntax
        while (queue.length) {
            // remove the first element
            const cfSlug = queue.shift();
            if (!cfSlug)
                continue;
            // if we have already visited this cfSlug, skip it
            if (visitedCfSlugs.has(cfSlug))
                continue;
            // add to global visited
            visitedCfSlugs.add(cfSlug);
            // add cfSlug to this BFS pass result
            cfSlugSet.add(cfSlug);
            // lookup lpSlugs
            const lpSlugs = cfToLpMap[cfSlug];
            (0, common_1.finleyAssert)(lpSlugs, `unable to get loanProductSlugs from cfToLpMap for ${cfSlug}`);
            // add slugs to this BFS pass result
            lpSlugs.forEach((slug) => lpSlugSet.add(slug));
            // explore the rest of associated cfIds
            lpSlugs.forEach((lpSlug) => {
                const cfSlugs = lpToCfMap[lpSlug];
                cfSlugs.forEach((slug) => queue.push(slug));
            });
        }
        // add this BFS result to the global result
        meshes.push({
            loanProducts: Array.from(lpSlugSet).sort(),
            creditFacilities: Array.from(cfSlugSet).sort(),
        });
    });
    return meshes.sort((a, b) => {
        if (a.loanProducts[0] < b.loanProducts[0])
            return -1;
        if (a.loanProducts[0] > b.loanProducts[0])
            return 1;
        return 0;
    });
};
exports.getLpCfGroupings = getLpCfGroupings;
//# sourceMappingURL=mesh.js.map